(function () {
  'use strict';

  function bindRow(row) {
    if (row.dataset.bound === 'true') return;
    row.dataset.bound = 'true';

    var items = row.querySelectorAll('.custom-lifestyle-gallery__item');
    if (!items.length) return;

    items.forEach(function (item) {
      item.addEventListener('mouseenter', function () {
        items.forEach(function (sibling) {
          if (sibling === item) {
            sibling.classList.add('is-active');
            sibling.classList.remove('is-dimmed');
          } else {
            sibling.classList.remove('is-active');
            sibling.classList.add('is-dimmed');
          }
        });
      });
    });

    row.addEventListener('mouseleave', function () {
      items.forEach(function (item) {
        item.classList.remove('is-active');
        item.classList.remove('is-dimmed');
      });
    });
  }

  function init() {
    var desktop = window.matchMedia('(min-width: 750px)');
    if (!desktop.matches) return;

    document
      .querySelectorAll('.custom-lifestyle-gallery .custom-lifestyle-gallery__row')
      .forEach(bindRow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var rows = event.target.querySelectorAll('.custom-lifestyle-gallery__row');
    if (window.matchMedia('(min-width: 750px)').matches) {
      rows.forEach(bindRow);
    }
  });
})();
